<template>
  <div v-if="dataUser.IndAutenticado">
    <v-divider color="#D3BC8D" v-if="numPromo != 0" />
    <v-toolbar
      style="color: 'white'"
      class="subtitle-2 font-weight-bold text-uppercase"
      flat
      color="primary"
      dark
      dense
      
      v-if="numPromo != 0"
    >
      <v-row>
        <v-col
          cols="9"
          class="text-left ml-1 mt-1 subtitle-2 font-weight-bold text-uppercase"
          @click="itempromo(checkPromo)"
          style="cursor: pointer;"
        >
          Articulos en Promoción
          <v-badge
            v-if="numPromo"
            color="info"
            
            :content="numPromo"
            class="font-weight-medium body-2 ml-2"
          >
          </v-badge>
        </v-col>
        <v-col
          class="text-right  subtitle-2 font-weight-medium text-uppercase"
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
              dark
               
               
                right
                absolute
                x-small
                @click="itempromo(checkPromo)"
                v-bind="attrs"
                v-on="on"
                elevation="0"
              >
                <v-icon  size="35" v-if="filter.promo === false"
                  >mdi-tag</v-icon
                >
                <v-icon  size="35" v-else> mdi-close</v-icon>
              </v-btn>
            </template>
            <span>{{`${filter.promo === true ? 'Ver Todo' : 'Ver Articulos en Promoción'}`}}</span>
          </v-tooltip>
        </v-col>
      </v-row>

      <!-- @click="limpiaPromo()" -->
    </v-toolbar>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
export default {
  data() {
    return {
      checkPromo: false,
    };
  },

  watch: {
    $route(to, from) {
      this.checkPromo = false;
    },
  },
  props: {},
  methods: {
    ...mapMutations(["GET_BUSCARPROMO", "CLR_BUSCARPROMO"]),
    limpiaPromo() {
      this.checkPromo = false;
      this.CLR_BUSCARPROMO();
    },
    itempromo(valor) {
      this.GET_BUSCARPROMO(valor);
      return this.checkPromo === true
        ? (this.checkPromo = false)
        : (this.checkPromo = true);
    },
  },
  computed: {
    ...mapGetters(["filterconsolidado"]),
    ...mapState(["filter", "dataUser"]),
    numPromo() {
      return this.filterconsolidado.filter((x) => x.Promocion === true).length;
    },
  },
};
</script>

<style scoped>
</style>